import { createContext, useEffect, useState } from 'react';
import { getCommitteeList } from '../services/api';
import i18n from '../i18n';

export const AgendaContext = createContext(null);

export default function AgendaContextProvider({ children }) {
    const [isLanguageEn, setIsLanguageEn] = useState(() => {
        return JSON.parse(localStorage.getItem('is_language_en')) ?? false; 
    });

    // Committee selection
    const [committeeList, setCommitteeList] = useState([]); // List of all committees
    const [committeeName, setCommitteeName] = useState(() => { // Selected committee
        return JSON.parse(localStorage.getItem('committee_name')) ?? '';
    });

    // Meeting details
    const [selectedMeetingType, setSelectedMeetingType] = useState(localStorage.getItem('selected_meeting_type') ?? '');
    const [roles, setRoles] = useState([]); // Committee roles: SEK contact, contact person, chairman and secretary
    const [meetingNumber, setMeetingNumber] = useState(localStorage.getItem('meeting_number') ?? '');
    
    // Loading state 
    const [isAgendaContentLoading, setIsAgendaContentLoading] = useState(false); 
    const [isAgendaContentVisible, setIsAgendaContentVisible] = useState(false); 

    // Remote participation
    const [meetingLink, setMeetingLink] = useState(localStorage.getItem('meeting_link') ?? '');
    const [meetingId, setMeetingId] = useState(localStorage.getItem('meeting_id') ?? '');
    const [meetingPassCode, setMeetingPassCode] = useState(localStorage.getItem('meeting_passcode') ?? '');
    
    // Agenda 
    const [toggleToc, setToggleToc] = useState(() => {
        return JSON.parse(localStorage.getItem('toggle_table_of_contents')) ?? true; 
    })
    const [previousProtocol, setPreviousProtocol] = useState(localStorage.getItem('previous_protocol') ?? ''); // Approval of the minutes from the previous meeting
    const [lastMeeting, setLastMeeting] = useState(localStorage.getItem('last_meeting') ?? '');
    const [nextMeeting, setNextMeeting] = useState(() => {
        return JSON.parse(localStorage.getItem('next_meeting')) ?? [];
    });

    const [meetingDates, setMeetingDates] = useState([]); // Contains lastMeeting and nextMeeting

    const [selectedStartTime, setSelectedStartTime] = useState(() => {
        return JSON.parse(localStorage.getItem('meeting_start_time')) ?? null;
    });

    const [selectedEndTime, setSelectedEndTime] = useState(() => {
        return JSON.parse(localStorage.getItem('meeting_end_time')) ?? null;
    });

    const [participants, setParticipants] = useState([]); // Participants
    const [participantsIsOpened, setParticipantsIsOpened] = useState(() => {
        return JSON.parse(localStorage.getItem('participants_is_open')) ?? false; 
    }); 
    const [correspondenceDocs, setCorrespondenceDocs] = useState([]); // Consensus by correspondence
    const [iecActionDocs, setIecActionDocs] = useState([]) // IEC documents for action

    const [clcActionDocs, setClcActionDocs] = useState(() => { // CENELEC documents for action
        return JSON.parse(localStorage.getItem('clc_action_docs')) ?? [];
    });

    const [upComingSweMeetings, setUpComingSweMeetings] = useState([]); // Upcoming Swedish meetings
    const [upComingIntlMeetings, setUpIntlComingMeetings] = useState([]); // Upcoming international meetings
    const [proposalForSweTitles, setProposalForSweTitles] = useState([]); // Proposal for swedish titles
    const [recentlyDeterminedPubl, setRecentlyDeterminedPubl] = useState([]);  // Recently determined publications
   
    const [iecClcWgReports, setIecClcWgReports] = useState(() => { // Reports from IEC & CENELEC working groups
        return JSON.parse(localStorage.getItem('reports_IEC_CLC')) ?? [];
    });

    const [iecInfoDocs, setIecInfoDocs] = useState([]);  // IEC documents for information
    const [plenaryScheduleImage, setPlenaryScheduleImage] = useState(() => {
        return JSON.parse(localStorage.getItem('plenary_schedule_image')) ?? null
    });

    const [clcInfoDocs, setClcInfoDocs] = useState(() => { // CENELEC documents for information
        return JSON.parse(localStorage.getItem('clc_info_docs')) ?? [];
    });

    const [editableSections, setEditableSections] = useState({
        otherInfoAndActivities: JSON.parse(localStorage.getItem('other_info_and_activities')) ?? [],
        anyOtherBusiness: JSON.parse(localStorage.getItem('any_other_business')) ?? [],
        recurringTopics: JSON.parse(localStorage.getItem('recurring_topics')) ?? [], 
    }); 

    useEffect(() => {
        getCommitteeList().then(data => setCommitteeList(data));
    }, [])

    useEffect(() => {
        i18n.changeLanguage(isLanguageEn ? 'en' : 'sv')
    }, [isLanguageEn]); 

    return (
        <AgendaContext.Provider
            value={{
                iecActionDocs, setIecActionDocs, iecInfoDocs, setIecInfoDocs, committeeList, 
                participants, setParticipants, nextMeeting,
                setNextMeeting, selectedStartTime, setSelectedStartTime,
                selectedEndTime, setSelectedEndTime,
                committeeName, setCommitteeName, lastMeeting, setLastMeeting,
                meetingLink, setMeetingLink, meetingId, setMeetingId, meetingPassCode, setMeetingPassCode,
                selectedMeetingType, setSelectedMeetingType,
                roles, setRoles, meetingNumber,
                setMeetingNumber, previousProtocol, setPreviousProtocol,
                iecClcWgReports, setIecClcWgReports, clcInfoDocs, setClcInfoDocs, clcActionDocs, setClcActionDocs,
                correspondenceDocs, setCorrespondenceDocs,
                isAgendaContentLoading, setIsAgendaContentLoading, isAgendaContentVisible, setIsAgendaContentVisible,
                plenaryScheduleImage, setPlenaryScheduleImage, upComingIntlMeetings, setUpIntlComingMeetings, 
                upComingSweMeetings, setUpComingSweMeetings, 
                proposalForSweTitles, setProposalForSweTitles, meetingDates, setMeetingDates,  
                toggleToc, setToggleToc, recentlyDeterminedPubl, setRecentlyDeterminedPubl, 
                isLanguageEn, setIsLanguageEn, participantsIsOpened, setParticipantsIsOpened, 
                editableSections, setEditableSections
            }}
        >
            {children}
        </AgendaContext.Provider>
    )
}